module.exports = __webpack_public_path__ + "static/media/work3.3b765113.jpg";